import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import TourIcon from '@mui/icons-material/Explore'
import { useTour } from '@reactour/tour'
import { useAppStore } from '@/store/appStore'
import { MainContentArea } from '@/components/layout/MainContentArea'

export function WelcomePage() {
  const { t } = useTranslation()
  const { setOverlayPage } = useAppStore()
  const { setIsOpen, setCurrentStep } = useTour()

  const handleStartTour = () => {
    setCurrentStep(0)
    setIsOpen(true)
  }

  return (
    <MainContentArea>
      <div className="welcome-page">
        <h1 className="welcome-title">{t('welcome.title')}</h1>
        <p className="welcome-body">{t('welcome.body')}</p>
        <ul className="welcome-hints">
          <li>
            {t('welcome.hintSelectPA')}
          </li>
          <li>
            {t('welcome.hintOverview')}{' '}
            <Button
              className="welcome-link-btn"
              variant="text"
              onClick={() => setOverlayPage({ type: 'overview' })}
              sx={{ padding: '0 4px', minWidth: 'unset', verticalAlign: 'baseline', lineHeight: 'inherit' }}
            >
              {t('welcome.overviewLink')}
            </Button>
            {t('welcome.hintOverviewSuffix')}
          </li>
        </ul>

        <Button
          className="welcome-tour-btn"
          variant="outlined"
          startIcon={<TourIcon />}
          onClick={handleStartTour}
          sx={{ mt: 3 }}
        >
          {t('welcome.takeTour')}
        </Button>
      </div>
    </MainContentArea>
  )
}
